module.exports = __webpack_public_path__ + "img/table-plus-2.84135288.svg";